import {
  AGREEMENT_SECTION_1,
  AGREEMENT_SECTION_2,
  AGREEMENT_SECTION_3,
  AGREEMENT_SECTION_4,
  AGREEMENT_SECTION_5,
  AGREEMENT_SECTION_6,
  AGREEMENT_SECTION_7,
  AGREEMENT_SECTION_8,
  AGREEMENT_SECTION_9,
} from './agreementSectionsPartOne';
import {
  AGREEMENT_SECTION_10,
  AGREEMENT_SECTION_11,
  AGREEMENT_SECTION_12,
  AGREEMENT_SECTION_13,
  AGREEMENT_SECTION_14,
  AGREEMENT_SECTION_15,
  AGREEMENT_SECTION_16,
  AGREEMENT_SECTION_17,
  AGREEMENT_SECTION_18,
} from './agreementSectionsPartTwo';
import {
  CONSENT_SECTION_1,
  CONSENT_SECTION_2,
  CONSENT_SECTION_3,
  CONSENT_SECTION_4,
  CONSENT_SECTION_5,
} from './consentSections';

import type { TitleBulletListSection } from '../../../../../common';

export {
  AGREEMENT_CONSENT_CHECKBOX_FIELDS,
  AGREEMENT_CONSENT_REQUIRED_ERROR_MESSAGE,
} from './form';

export {
  AGREEMENT_SECTION_1,
  AGREEMENT_SECTION_2,
  AGREEMENT_SECTION_3,
  AGREEMENT_SECTION_4,
  AGREEMENT_SECTION_5,
  AGREEMENT_SECTION_6,
  AGREEMENT_SECTION_7,
  AGREEMENT_SECTION_8,
  AGREEMENT_SECTION_9,
  AGREEMENT_SECTION_10,
  AGREEMENT_SECTION_11,
  AGREEMENT_SECTION_12,
  AGREEMENT_SECTION_13,
  AGREEMENT_SECTION_14,
  AGREEMENT_SECTION_15,
  AGREEMENT_SECTION_16,
  AGREEMENT_SECTION_17,
  AGREEMENT_SECTION_18,
  CONSENT_SECTION_1,
  CONSENT_SECTION_2,
  CONSENT_SECTION_3,
  CONSENT_SECTION_4,
  CONSENT_SECTION_5,
};

export const ONBOARDING_CONSENT_SECTIONS: TitleBulletListSection[] = [
  CONSENT_SECTION_1,
  CONSENT_SECTION_2,
  CONSENT_SECTION_3,
  CONSENT_SECTION_4,
  CONSENT_SECTION_5,
];

export const ONBOARDING_AGREEMENT_SECTIONS: TitleBulletListSection[] = [
  AGREEMENT_SECTION_1,
  AGREEMENT_SECTION_2,
  AGREEMENT_SECTION_3,
  AGREEMENT_SECTION_4,
  AGREEMENT_SECTION_5,
  AGREEMENT_SECTION_6,
  AGREEMENT_SECTION_7,
  AGREEMENT_SECTION_8,
  AGREEMENT_SECTION_9,
  AGREEMENT_SECTION_10,
  AGREEMENT_SECTION_11,
  AGREEMENT_SECTION_12,
  AGREEMENT_SECTION_13,
  AGREEMENT_SECTION_14,
  AGREEMENT_SECTION_15,
  AGREEMENT_SECTION_16,
  AGREEMENT_SECTION_17,
  AGREEMENT_SECTION_18,
];
